// src\app\components\includes\data\fulle-basket-endorder\fulle-basket-endorder.component.ts
import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Renderer2,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { PanierService } from "src/app/services/manage/panier/panier.service";
import { ToolsService } from "src/app/services/tools/tools.service";
import { Product } from "src/app/models/class/product";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MediaObserver } from "@angular/flex-layout";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { ClientaddressesService } from "src/app/services/apiclient/clientaddresses/clientaddresses.service";
import { FulleStockService } from "src/app/services/api/fulle/fulle-stock/fulle-stock.service";
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { MyStripeService } from "src/app/services/apiclient/myStripe/my-stripe.service";
import { ClientaccountService } from "src/app/services/apiclient/clientaccount/clientaccount.service";
import { PayzenComponent } from "src/app/components/dialogs/payzen/payzen.component";
import { StripeWebComponent } from "src/app/components/stripe-web/stripe-web.component";
import { MyPosComponent } from "src/app/components/my-pos/my-pos.component";
import { PaymentTouchTerminalComponent } from "src/app/components/dialogs/payment-touch-terminal/payment-touch-terminal.component";
import { Touchterminalpayment } from "src/app/services/api/touchterminalpayment/touchterminalpayment.service";
import { borneOrderService } from "src/app/services/borneOrder/borneOrder.service";
import { TranslateService } from "@ngx-translate/core";
import { loadStripe } from "@stripe/stripe-js";
import { DeviceCheck } from "src/app/services/api/DeviceCheck/DeviceCheck.service";
import { CapturedPaymentComponent } from "src/app/components/captured-payment/captured-payment.component";
import { NeptingService } from "src/app/services/apiclient/nepting/nepting.service";
import { CssService } from "../../../../../services/css-service";
import { SalemethodService } from "../../../../../services/api/salemethod/salemethod.service";

declare const paypal: any;

export type UberQuote = {
  created: string;
  currency: string;
  currency_type: string;
  dropoff_deadline: string;
  dropoff_eta: string;
  duration: number;
  expires: string;
  fee: number;
  id: string;
  kind: string;
  pickup_duration: number;
  reference: string;
};

@Component({
  selector: 'app-fulle-basket-endorder',
  templateUrl: './fulle-basket-endorder.component.html',
  styleUrls: ['./fulle-basket-endorder.component.css']
})
export class FulleBasketEndorderComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('paypal') paypalElement: ElementRef | any;

  @Input() activeButton: boolean | any;
  @Input() selectedRelay: any;
  @Input() isRelay: any;
  @Input() orderCard: any;
  @Input() billingAddress: any;
  @Input() delivryAddress: any;
  @Input() currPaymentChoice: string | any;
  @Input() error: string | any;
  @Input() merchantClient: any;
  @Input() credit_fid: any;
  @Input() activeDeviceandButtonTerms: any;
  @Input() errorYetPayed: any;
  @Input() uberQuote: UberQuote | undefined = undefined;
  @Output() readErrorsEvent: EventEmitter<any> = new EventEmitter();
  @Output() setPageLoaderEvent: EventEmitter<any> = new EventEmitter();

  default_prod: string =
    "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  currPos: any = this.tools.getStor("point_of_sale");
  panier$: Product[] = [];
  totalQuantPan: number | any;
  totalPricePan: number | any;
  totalWeightPan: number | any;
  maxWeightPan: number | any;
  shippingPrice: number | any;
  shippingOffer: number | any;
  needRelay: boolean = false;
  deliveryPrice: number | any;
  deliveryOffer: number | any;
  allTotal: number | any;
  totalOldPricePan: number | any;
  numQuant: number[] = [];
  quantityChanged: any = null;
  salesTerms: boolean = false;
  errorMessage: string | any;
  needSalesTerms: boolean | any;
  stripe: any;
  clientAccount: any;
  loader: boolean = false;
  discountClient = 0;
  totalAfterDiscount = 0;
  fidelityDiscountUsed = 0;
  interval: any = null;
  time = 0;
  orderIntentStatus: any;
  obserGetStripeKey: any;
  statusMessage: any;

  // Uber
  isUberDirectEnabled = false;
  uberFee = 0;

  constructor(
    private panierMan: PanierService,
    public tools: ToolsService,
    private addressApi: ClientaddressesService,
    public dialog: MatDialog,
    public cssService: CssService,
    public myDials: DialogsService,
    public media: MediaObserver,
    public renderer: Renderer2,
    private stockApi: FulleStockService,
    private orderApi: ClientOrdersService,
    private stripeApi: MyStripeService,
    private clientAccountApi: ClientaccountService,
    private Touchterminalpayment: Touchterminalpayment,
    private borneOrderService: borneOrderService,
    public translate: TranslateService,
    private DeviceCheck: DeviceCheck,
    public NeptingService: NeptingService,
  ) { }

  async ngOnInit() {
    this.statusMessage = "";
    this.unmountStripe();
    //stock
    this.checkCurrentStock().then(() => {
      this.addressApi.getDelivryAddress.subscribe((address) => {
        this.delivryAddress = address;
        this.getInfoPan();
        this.getInfoShipping();
      });
      //panier
      this.panierMan.getPanier.subscribe((basket) => {
        this.panier$ = basket;
        this.getInfoPan();
        this.getInfoShipping();
      });
      // Récupère la fiche client account du client connecté
      this.clientAccountApi.getClientAccount().subscribe(data => {
        this.clientAccount = data;
      })
    });
  }

  //detruit les observables
  ngOnDestroy(): void {
    if (this.obserGetStripeKey) {
      this.obserGetStripeKey.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges | any): void {
    //active Device and ButtonTerms
    if (changes.activeDeviceandButtonTerms) {
      this.activeDeviceandButtonTerms = changes.activeDeviceandButtonTerms.currentValue
      this.salesTerms = changes.activeDeviceandButtonTerms.currentValue ? true : false;
      if (changes.activeDeviceandButtonTerms.currentValue) {
        this.needSalesTerms = false;
      }
    }
    //panier
    if ((changes.selectedRelay && changes.selectedRelay.currentValue) || changes.isRelay) {
      this.getInfoPan();
      this.getInfoShipping();
    }
    //credit fid or discount client
    if (changes.merchantClient && changes.merchantClient.currentValue) {
      this.merchantClient = changes.merchantClient.currentValue;
      if (!this.merchantClient || (this.merchantClient && !this.merchantClient.credit_fidelity_amount)) {
        this.credit_fid = false;
        this.discountClient = 0;
      }
      this.getInfoPan();
    }
    //change credit fid
    if (changes.credit_fid) {
      this.credit_fid = changes.credit_fid.currentValue;
      this.getInfoPan();
    }
    // change currPaymentChoice
    if (changes.currPaymentChoice && changes.currPaymentChoice.currentValue) {
      if (this.currPaymentChoice == "touch_terminal") {
        this.salesTerms = true,
          this.needSalesTerms = false;
      }
      this.initialiseLibraries();
    }
    //stripe captured
    if (changes.errorYetPayed && changes.errorYetPayed.currentValue) {
      this.openDialogStatusStripeCapuredSucceded(changes.errorYetPayed)
    }
    // uber
    if (changes['uberQuote']) {
      // console.log("fulle-basket-endorder.component - ngOnChanges - uberQuote : ", this.uberQuote);
      // console.log("fulle-basket-endorder.component - ngOnChanges - this.currSm : ", this.currSm);
      this.isUberDirectEnabled = true;
      if (this.uberQuote && this.uberQuote.fee > 0)
        this.uberFee = this.uberQuote.fee / 100;
      this.getInfoPan();
      this.getInfoShipping();
    }
  }

  // Initialise Stripe ou paypal
  initialiseLibraries() {
    // Initialise Stripe
    if (this.currPaymentChoice === "online" || this.currPaymentChoice === "secure_counter" || this.currPaymentChoice === "bancontact"
      || this.currPaymentChoice === "stripe"
    ) {
      this.obserGetStripeKey = this.stripeApi.getStripeKey().subscribe(async key => {
        if (key) {
          this.stripe = await loadStripe(key);
        }
      });
    }

    // Initialise Paypal
    if (this.currPaymentChoice === "online_paypal" || this.currPaymentChoice === "secure_counter_paypal") {
      setTimeout(() => {
        this.initPaypal();
      }, 50);
    }
  }

  // Change la quantité d'un produit et dans le stock
  update_stock(prod: any) {
    if (prod.stock) {
      prod.stock.count = this.stockApi.handleProdStock(
        prod.id,
        this.quantityChanged,
        "remove",
        prod.stock.newcount
      );
    }

    if (prod.details) {
      prod.details.map((det: any) => {
        if (det.stock) {
          det.stock.count = this.stockApi.handleProdStock(
            det.id,
            this.quantityChanged,
            "remove",
            det.stock.newcount
          );
        }
      });
    }
    return this.stockApi.stocks;
  }

  // Récupère toutes les infos du panier
  getInfoPan(): void {
    this.totalQuantPan = this.panierMan.getQuant();
    this.totalPricePan = this.panierMan.getPrice();
    this.totalWeightPan = this.panierMan.getWeight();
    if (this.isRelay && !this.selectedRelay) {
      this.allTotal = this.totalPricePan;
    } else {
      // console.log("fulle-basket-endorder.component - ngOnChanges - this.uberQuote : ", this.uberQuote)

      this.allTotal = this.panierMan.getPanInfos(
        "allship",
        this.isRelay ? this.selectedRelay : null,
        this.uberQuote ? this.uberQuote?.fee / 100 : undefined);
    }
    //check remise
    this.fidelityDiscountUsed = 0
    this.allTotal = this.getPriceRemise();
    if (this.credit_fid && this.merchantClient && this.merchantClient.credit_fidelity_amount) {
      const priceWithDiscount: any = this.totalPricePan - this.discountClient;
      //total fidelity use
      this.fidelityDiscountUsed = priceWithDiscount > this.merchantClient.credit_fidelity_amount ? this.merchantClient.credit_fidelity_amount : this.totalPricePan - this.discountClient;
      //calcul all total
      this.allTotal = this.allTotal - this.fidelityDiscountUsed;
    }
  }

  // calcul l'ecart entre ancienne et nouvelle qté stock
  QtyStockChange(newQty: number, oldQty: number) {
    this.quantityChanged = newQty - oldQty;
  }

  getInfoShipping() {
    // Livraison
    // this.deliveryPrice = this.panierMan.getPanInfos("delivery");
    // console.log("fulle-basket-endorder.component - getInfoShipping - this.uberQuote : ", this.uberQuote)

    this.deliveryPrice = this.panierMan.getPanInfos("delivery", this.isRelay ? this.selectedRelay : null, this.uberQuote ? this.uberQuote.fee / 100 : undefined);
    // console.log("fulle-basket-endorder.component - getInfoShipping - this.deliveryPrice : ", this.deliveryPrice)
    this.deliveryOffer = this.panierMan.getPanInfos("deliveryOffer");
    // console.log("fulle-basket-endorder.component - getInfoShipping - this.deliveryOffer : ", this.deliveryOffer)

    // if (this.uberQuote) {
    //   this.deliveryPrice = this.uberQuote.fee / 100;
    //   console.log("fulle-basket-endorder.component - getInfoShipping - this.deliveryPrice : ", this.deliveryPrice)
    // }


    // Expedition
    this.shippingPrice =
      this.isRelay && this.selectedRelay
        ? this.addressApi.getShippingPrice(this.panier$, this.selectedRelay)
        : this.addressApi.getShippingPrice(this.panier$, null);
    this.shippingOffer =
      this.delivryAddress && this.delivryAddress.shipping_mode
        ? this.delivryAddress.shipping_mode.offered_from
        : null;
    this.needRelay = this.isRelay && !this.selectedRelay ? true : false;
  }

  // on change le stock lors d'une suppression d'une formule qui à un produit avec du stock
  changeStock(prod: any): void {
    if (prod.details.length > 0)
      for (let i = 0; i < prod.details.length; i++) {
        const item = prod.details[i];
        if (item.stock) {
          this.stockApi.handleProdStock(
            item.id,
            item.quantity * prod.quantity,
            "add",
            item.stock.newcount
          );
        }
      }
  }

  //goTerms
  goTerms(): void {
    const merchantName: any = this.tools.getStor("url_encode");
    const pointOfSale: any = this.tools.getStor("point_of_sale");
    window.open(window.location.origin + "/merchantTerms" + "/" + merchantName + "/" + pointOfSale.id_webshop, "_blank");
  }

  //open pop stock negative
  checkCurrentStock(setPageLoader = false): Promise<any> {
    return this.stockApi.displayAlertStockDialog(setPageLoader ? this.setPageLoaderEvent : null, true)
  }

  // Initialise et configure stripe
  initPaypal(): void {
    paypal.Buttons(
      {
        commit: true,
        style: {
          height: 40,
          layout: 'horizontal',
          tagline: false,
          size: 'responsive',
          color: 'gold',
          shape: 'pill',
          label: 'paypal',
        },
        createOrder: async function () {
          const data = await this.submitPaypalOrder();
          const orderData = data;
          return orderData.id;
        },
        onApprove: function (data: any) {
          this.submitPaypalOrder(data.orderID);
        },
        onClick: () => {
          if (this.salesTerms) {
            this.needSalesTerms = false;
            return true;
          } else {
            this.needSalesTerms = true;
            return false;
          }
        },
        onCancel: function () {
          this.setPageLoader(false);
        },
        onError: function () {
          // Show an error page here, when an error occurs TODO
        }
      }
    ).render(this.paypalElement.nativeElement);
  }

  test(): Promise<any> { // TODO
    return new Promise((resolve) => {
      // Check stock befor
      setTimeout(() => {
        resolve('ok')
      }, 2000);
    })
  }

  // Créer une commande (Paypal)
  submitPaypalOrder(paypal_order_id?: any, order_id_device?: any): Promise<any> {
    this.tools.removeStor("credit_fid");
    this.setPageLoader(true);
    this.error = null;
    return new Promise((resolve, reject) => {
      // Vérification des stocks
      this.checkCurrentStock(true).then((result) => {
        if (result.data) {
          this.orderApi.checkError(
            this.orderCard,
            this.billingAddress,
            this.delivryAddress,
            this.selectedRelay,
            this.isRelay,
            this.isUberDirectEnabled && this.uberQuote ? this.uberQuote.fee : 0,
          ).then((data) => {
            // Si erreur
            if (data) {
              setTimeout(() => {
                this.readErrors(data);
                this.setPageLoader(false);
              });
              reject();
              // Si pas d'erreur on crée la commande
            } else {
              this.readErrors(null);
              //erreur expiration de date
              if (this.tools.checkExpiryDatebeforePay()) {
                return;
              }
              this.orderApi.submitOrder(
                this.currPaymentChoice, // "counter" / "secure_counter" / "online_paypal" / ...                
                this.orderCard, // currCard
                this.billingAddress, // billingAddress
                this.delivryAddress, // delivryaddress
                (this.isRelay ? this.selectedRelay : null), // relay
                paypal_order_id, // paypal_order_id
                null, //payment_intent_id
                this.merchantClient, // merchantClient
                null, //paymentIntentId
                order_id_device, // order_id_device
                null, // url
                null, // payment_intent_id_saved
                this.uberFee // uberFee
              ).then(
                data => {
                  // Success
                  if (data.code === 0) {
                    this.handlePaymentSuccess();
                  }
                  // Paypal order creation
                  else if (data.code === -3) {
                    resolve(data.paypal_order);
                  }
                  // Erreur
                  else {
                    if (data && data.code && data.code === -134) {
                      this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
                    }
                    if (data && data.code && data.code == -60) {
                      //pas de client
                      data.message = this.translate.instant('nocustomers');
                    } else if (data && data.code && data.code === -100) {
                      this.openDialogStatusStripeCapuredSucceded()
                    } else {
                      this.tools.openSnackBar(data.message ? data.message : this.translate.instant('loginComp.error'), "warn", 10000);
                    }
                    this.setPageLoader(false);
                    reject();
                  }
                }
              );
            }
          })
        }
      });
    })
  }


  // Appui sur "Finaliser la commande"
  // presubmitOrder() {
  //   // Barre progression
  //   this.setPageLoader(true);
  //   // Récupération de l'identifiant de la commande en cours
  //   const order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
  //   // Si une commande est bien en cours
  //   if (order_id) {
  //     console.log("fulle-basket-endorder.component - presubmitOrder - order_id : ", order_id)

  //     const KeyPayIntent = this.currPaymentChoice == 'stripe' && this.tools.getStor("ClientKeyPayIntentOrder") ? this.tools.getStor("ClientKeyPayIntentOrder") : null;
  //     console.log("fulle-basket-endorder.component - presubmitOrder - KeyPayIntent : ", KeyPayIntent)

  //     // Vérification du paiement de la commande ?
  //     this.orderApi.checkOrderPayment(order_id, KeyPayIntent).then((data: any) => {
  //       console.log("fulle-basket-endorder.component - presubmitOrder - data : ", data)

  //       if (data && data.code == 0) {
  //         if (data.orderPayment && data.orderPayment.captured == 1 || data.paiement && data.paiement.status == "succeeded") {
  //           //error
  //           const error = {
  //             error: {
  //               text: "erroryetpaymentStripe",
  //               orderCaptured: data.orderPayment ? data.orderPayment.captured : null,
  //               paimentStatus: data.paiement && data.paiement.status ? data.paiement.status : null
  //             }
  //           }
  //           this.setPageLoader(false);
  //           this.openDialogStatusStripeCapuredSucceded(error);
  //         } else {
  //           this.submitOrder();
  //         }
  //       }
  //     })
  //   }
  // }

  presubmitOrder() {
    this.setPageLoader(true);

    const order_id = this.tools.getStor("order_id") ?? null;
    if (!order_id) return;

    // uniquement pour Stripe
    if (this.currPaymentChoice === "stripe") {
      const key = this.tools.getStor("ClientKeyPayIntentOrder") ?? null;
      this.orderApi.checkOrderPayment(order_id, key).then((data: any) => {
        if (data?.code === 0 && (data?.orderPayment?.captured === 1 || data?.paiement?.status === "succeeded")) {
          this.setPageLoader(false);
          this.openDialogStatusStripeCapuredSucceded({ error: { text: "erroryetpaymentStripe" } });
          return;
        }
        this.submitOrder();
      });
      return;
    }

    // comptoir / autres
    this.submitOrder();
  }


  // Créer une commande (Stripe, paiement au comptoir)
  submitOrder(payment_intent_id?: any, order_id_device?: any): void {
    // console.log("fulle-basket-endorder.component - submitOrder - payment_intent_id : ", payment_intent_id)
    // console.log("fulle-basket-endorder.component - submitOrder - order_id_device : ", order_id_device)

    this.tools.removeStor("credit_fid");
    if (this.credit_fid) {
      // on sauvegarde la fidelity utilisé
      this.tools.setStor("credit_fid", this.fidelityDiscountUsed);
    }
    this.setPageLoader(true);
    this.error = null;
    // Check stock befor
    this.checkCurrentStock(true).then((result) => {
      if (result.data) {
        this.submitOrderAfterStock(payment_intent_id, order_id_device);
      }
    });
  }

  submitOrderAfterStock(payment_intent_id?: any, order_id_device?: any) {
    // console.log("fulle-basket-endorder.component - submitOrderAfterStock - payment_intent_id : ", payment_intent_id)
    // console.log("fulle-basket-endorder.component - submitOrderAfterStock - order_id_device : ", order_id_device)
    // console.log("fulle-basket-endorder.component - submitOrderAfterStock - this.isUberDirectEnabled : ", this.isUberDirectEnabled)
    // console.log("fulle-basket-endorder.component - submitOrderAfterStock - this.uberQuote : ", this.uberQuote)

    this.setPageLoader(true);
    this.orderApi.checkError(
      this.orderCard,
      this.billingAddress,
      this.delivryAddress,
      this.selectedRelay,
      this.isRelay,
      this.isUberDirectEnabled && this.uberQuote ? this.uberQuote.fee : 0,
    ).then((data_from_checkError) => {
      if (data_from_checkError) { // Si erreur
        setTimeout(() => {
          this.readErrors(data_from_checkError);
          this.setPageLoader(false);
        });
      } else { // Si aucune erreur alors on crée la commande
        // this.readErrors(null);
        if (!this.salesTerms) { // On check si les conditions génér de vente sont cochées
          this.needSalesTerms = true;
          this.setPageLoader(false);
          return;
        }
        if (this.tools.checkExpiryDatebeforePay()) { //on check si date expiry
          return
        }
        // On check le montant
        if (this.currPaymentChoice == "stripe" || this.currPaymentChoice == "myPos") {
          // On verifie l'oder amount
          this.orderApi.checkOrderAmount(
            this.billingAddress, // billingAddress
            this.delivryAddress, // delivryaddress
            (this.isRelay ? this.selectedRelay : null), // relay
            this.merchantClient, // merchantClient
            "checkOpenPof", // checkopenpof
            this.uberQuote ? this.uberQuote.fee / 100 : 0 // uberFee
          ).then((data_from_checkOrderAmount: any) => {
            // console.log("fulle-basket-endorder.component - submitOrderAfterStock - data_from_checkOrderAmount : ", data_from_checkOrderAmount)
            // Success
            if (data_from_checkOrderAmount.code === 0) {
              // ouvre stripe payment ou mypos
              //order_intent_id
              data_from_checkOrderAmount.order_id_device = order_id_device ? order_id_device : null;
              // console.log("fulle-basket-endorder.component - submitOrderAfterStock - data.amount :", data_from_checkOrderAmount.amount)
              this.currPaymentChoice == "stripe" ? this.openStripePayment(data_from_checkOrderAmount, payment_intent_id) : this.openMyPosPayment(data_from_checkOrderAmount)
            } else {
              // On affiche un message d'erreur de paiement
              this.tools.openSnackBar(data_from_checkOrderAmount.message ? data_from_checkOrderAmount.message : this.translate.instant('loginComp.error'), "warn", 10000);
              this.setPageLoader(false);
            }
          });
          return;
        } else {
          const url = this.currPaymentChoice == "nepting" ? this.tools.getStor("neptingweblocation") : null;
          //creation commande et paiement (sauf stripe paiement)
          this.orderApi.submitOrder(
            this.currPaymentChoice, // "counter" / "secure_counter" / "online_paypal" / ...
            this.orderCard, // currCard
            this.billingAddress, // billingAddress
            this.delivryAddress, // delivryaddress
            (this.isRelay ? this.selectedRelay : null), // relay
            null, // paypal_order_id
            payment_intent_id, // payment_intent_id
            this.merchantClient, // merchantClient
            null, // paymentIntentId
            order_id_device, // order_id_device
            url, //url
            null, // payment_intent_id_saved?
            this.uberFee // uberFee?
          ).then(
            data_from_orderApi_submitOrder => {
              // console.log("fulle-basket-endorder.component - submitOrderAfterStock - data_from_orderApi_submitOrder : ", data_from_orderApi_submitOrder);
              // Success
              if (data_from_orderApi_submitOrder.code === 0) {
                this.handlePaymentSuccess();
              }
              // Stripe SCA
              else if (data_from_orderApi_submitOrder.code === -2) {
                this.tools.setStor("ClientKeyPayIntenCard", data_from_orderApi_submitOrder.pi);
                this.stripe.handleCardAction(
                  data_from_orderApi_submitOrder.payment_intent_client_secret
                ).then((result: any) => {
                  if (result.error) {
                    // On affiche un message d'erreur de paiement
                    this.tools.openSnackBar(result.error.message, "warn", 10000);
                    this.setPageLoader(false);
                  } else {
                    this.confirmOrderStripe(result.paymentIntent.id);
                  }
                });
              } else if (data_from_orderApi_submitOrder.code == -3) {
                // 3d secure new
                this.tools.setStor("ClientKeyPayIntenCard", data_from_orderApi_submitOrder.pi);
                this.stripe.confirmCardPayment(
                  data_from_orderApi_submitOrder.payment_intent_client_secret,
                  {
                    payment_method: data_from_orderApi_submitOrder.pi.payment_method,
                  },
                ).then((result: any) => {
                  if (result.error) {
                    // On affiche un message d'erreur de paiement
                    this.tools.openSnackBar(result.error.message, "warn", 10000);
                    this.setPageLoader(false);
                  } else {
                    if (result.paymentIntent.status == "succeeded" || (this.currPaymentChoice === "secure_counter" && result.paymentIntent.status == "requires_capture")) {
                      this.confirmOrderStripe(result.paymentIntent.id);
                    };
                  }
                })
              }
              // Bancontact
              else if (data_from_orderApi_submitOrder.code === -4) {
                this.saveOrderForRedirectPayment(data_from_orderApi_submitOrder.order_id);
                this.stripe.confirmBancontactPayment(
                  data_from_orderApi_submitOrder.pi_bancontact.client_secret,
                  {
                    payment_method: {
                      billing_details: {
                        name: this.clientAccount.firstname + " " + this.clientAccount.lastname,
                        email: this.clientAccount.mail,
                      },
                    },
                    return_url: window.location.origin + '/endorder',
                  }
                ).then(function (result: any) {
                  if (result.error) {
                    // TODO : Inform the customer that there was an error.
                  }
                });
              }
              // Payzen
              else if (data_from_orderApi_submitOrder.code === -5) {
                // open dialog payzen
                this.openPayzenCard(data_from_orderApi_submitOrder)
                this.setPageLoader(false);
              }
              // touch Terminal BORNE
              else if (data_from_orderApi_submitOrder.code === -8) {
                // open dialog Terminal borne
                this.openDialogtouchTerminal(data_from_orderApi_submitOrder);
              }
              // yavin
              else if (data_from_orderApi_submitOrder.code === -89) {
                window.location.href = data_from_orderApi_submitOrder.yavin_link.payment_link;
                return;
              }
              // nepting
              else if (data_from_orderApi_submitOrder.code === -90) {
                //  5071004150123060   06/25  000 ??????? TODO
                this.NeptingService.getForm(data_from_orderApi_submitOrder);
                console.log("[TYPAGE] : getForm(any) :", data_from_orderApi_submitOrder)
              }
              // ENABLE_DEVICE_CHECK
              else if (data_from_orderApi_submitOrder.code === -20) {
                this.setOrderIntentcheckDevice_(data_from_orderApi_submitOrder).then(() => {
                }).catch(err => {
                  console.error('err:', err)
                })
              }
              // Erreur
              else {
                this.setPageLoader(false);
                if (data_from_orderApi_submitOrder && data_from_orderApi_submitOrder.code && data_from_orderApi_submitOrder.code === -134) {
                  this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
                  this.setPageLoader(false);
                }
                // On affiche un message d'erreur de paiement/
                else {
                  if (data_from_orderApi_submitOrder && data_from_orderApi_submitOrder.code && data_from_orderApi_submitOrder.code === -1000) {
                    if (data_from_orderApi_submitOrder.err && data_from_orderApi_submitOrder.err.jsonBody && data_from_orderApi_submitOrder.err.jsonBody && data_from_orderApi_submitOrder.err.jsonBody.error && data_from_orderApi_submitOrder.err.jsonBody.error.message) {
                      data_from_orderApi_submitOrder.message = this.translate.instant('rechargeComponent.error3d');
                      data_from_orderApi_submitOrder.message += " \n \n " + this.translate.instant('rechargeComponent.error_stripe');
                    }
                    this.tools.openSnackBar(data_from_orderApi_submitOrder.message ? data_from_orderApi_submitOrder.message : this.translate.instant('loginComp.error'), "warn", 10000);
                    this.setPageLoader(false);
                  } else if (data_from_orderApi_submitOrder && data_from_orderApi_submitOrder.code && data_from_orderApi_submitOrder.code === -100) {
                    this.openDialogStatusStripeCapuredSucceded()
                  } else {
                    if (data_from_orderApi_submitOrder.err && data_from_orderApi_submitOrder.err.jsonBody && data_from_orderApi_submitOrder.err.jsonBody && data_from_orderApi_submitOrder.err.jsonBody.error && data_from_orderApi_submitOrder.err.jsonBody.error.message) {
                      data_from_orderApi_submitOrder.message = this.translate.instant('loginComp.error')
                      data_from_orderApi_submitOrder.message += "(" + data_from_orderApi_submitOrder.err.jsonBody.error.message + ")";
                    }
                    if (data_from_orderApi_submitOrder && data_from_orderApi_submitOrder.code && data_from_orderApi_submitOrder.code == -60) {
                      //no client
                      data_from_orderApi_submitOrder.message = this.translate.instant('nocustomers');
                    }
                    this.tools.openSnackBar(data_from_orderApi_submitOrder.message ? data_from_orderApi_submitOrder.message : this.translate.instant('loginComp.error'), "warn", 10000);
                    this.setPageLoader(false);
                  }
                }
              }
            }
          );
        }
      }
    })
  }

  confirmOrderStripe(payment_intent_id?: string) {
    this.submitOrder(payment_intent_id);
  }

  readErrors(error: any): void {
    this.readErrorsEvent.emit(error);
  }

  // Setter de la propriété pageLoader du composant parent (endorder)
  setPageLoader(value: boolean): void {
    this.setPageLoaderEvent.emit(value);
  }

  // Sauvegarde la commande pour la redirection de paiement (bancontact)
  saveOrderForRedirectPayment(orderId: number): void {
    const savedData = {
      billingAddress: this.billingAddress,
      delivryAddress: this.delivryAddress,
      relay: this.selectedRelay,
      order_id: orderId
    }
    this.tools.setStor("payment_save_order", savedData);
  }

  // ouvre la pop up card paiement (Payzen)
  openPayzenCard(value: any): void {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      data: value
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(PayzenComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (document.getElementById('krtoolbar')) {
        const krtoolbar: any = document.getElementById('krtoolbar')
        krtoolbar.style.display = 'none';
      }
      if (result) {
        this.loader = true;
        this.setPaymentPayzen(value.order_id, result.paiement.clientAnswer, value.orderPayment.id);
      }
    });
  }

  setPaymentPayzen(order_id: any, paiement: any, order_payment_id: any) {
    // route api lucas  id_order json result.paiement.clientAnswer
    // si success ->
    this.orderApi.setPaymentPayzen(order_id, paiement, order_payment_id).then(order => {
      if (order.code === 0) {
        this.handlePaymentSuccess();
      } else {
        this.loader = false;
        //error
        this.tools.openSnackBar(this.translate.instant('loginComp.error'), "warn", 5000);
      }
    }).catch(err => {
      console.error('err', err)
    })
    this.setPageLoader(false);
  }

  // ouvre la pop up stripe paiement
  openStripePayment(data?: any, payment_intent_id?: any): void {
    // console.log("fulle-basket-endorder.component - openStripePayment - data : ", data)
    // console.log("fulle-basket-endorder.component - openStripePayment - payment_intent_id : ", payment_intent_id)
    // console.log("fulle-basket-endorder.component - openStripePayment - this.clientAccount : ", this.clientAccount)
    // console.log("fulle-basket-endorder.component - openStripePayment - this.currSm : ", this.currSm)
    // console.log("fulle-basket-endorder.component - openStripePayment - this.panier$ : ", this.panier$)

    const dataOrder: any = {
      orderCard: this.orderCard, // Détails de la commande (Panier).
      billingAddress: this.billingAddress, // Adresse de facturation.
      delivryAddress: this.delivryAddress, // Adresse de livraison.
      selectedRelay: this.selectedRelay, // Informations sur le point relais si le mode de livraison est en point relais.
      isRelay: this.isRelay ? this.selectedRelay : null, // Idem TODO : Peut-etre faire une seule variable ?
      paypalOrder: null, // Ici Null car on est sur un payment Stripe. 
      payment_intent_id: payment_intent_id // identifiant d'intention de paiement. Il peut être utilisé pour reprendre un paiement existant.
    }
    this.setPageLoader(false); // Désactive le chargement de la page (roue crantée).
    // Configuration de la boite de dialog Stripe :
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      amount: data.amount, // Montant
      metadata: 1, // Origine du paiement
      dataOrder: dataOrder,
      merchantClient: this.merchantClient,
      checkOpenPof: true,
      id_user: this.merchantClient.id_user,
      stripe: this.stripe,
      uber: this.uberQuote,
    };
    // console.log("fulle-basket-endorder.component - openStripePayment - data.amount : ", data.amount);
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");
    // Ouverture de la popup de paiement Stripe :
    const myDial = this.dialog.open(StripeWebComponent, myConf);
    // A sa fermeture, quelques en soit la cause (OK, KO ou autre):
    myDial.afterClosed().subscribe((result) => {
      // On réactive le popState (voir la fonction pour détails):
      this.tools.setOnPopState(true);
      // Vérification du résultat
      if (!result || result && result.error) {
        // deux cas possible :
        // 
        // !result => la pop-up a été fermée sans renvoyer de résultats. Cela peut arriver quand le client ferme celle-ci,
        // appuie sur esc ou clique en dehors.
        //
        // result && result.error : La pop-up a renvoyé un résultat, mais ce résultat contient une propriété error, indiquant un échec de paiement.
        this.unmountStripe();
        this.tools.removeStor("payment_save_order_stripe"); // Supprime les informations temporaires sur la tentative de paiement.
        if (result && result.error) {
          console.error("fulle-basket-endorder.component - openStripePayment - le paiement Stripe a échoué pour la raison suivante : ", result.error);
          if (result.error == "errorpayintent") {
            // gestion spécifique d'une situation où l'intention de paiement a été créée mais a échouée.
            this.statusMessage = this.translate.instant("loaderRedirc_");
            this.loader = true;
            this.orderApi.redirectAfterErrorYetCaptured();
          } else {
            // gestion des autres cas d'erreur. La dialog a bien été capturée mais avec une erreur.
            this.openDialogStatusStripeCapuredSucceded(result.error);
          }
        }
      } else {
        // paiement réussi
        // console.log("fulle-basket-endorder.component - openStripePayment - result success : ", result);
        this.loader = true;
        this.handlePaymentSuccess();
      }
    });
  }

  // ouvre la pop up Stripe Capured Succeded
  openDialogStatusStripeCapuredSucceded(error?: any) {
    // console.log("fulle-basket-endorder.component - openDialogStatusStripeCapuredSucceded - error : ", error)
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.disableClose = true;
    myConf.data = {
      error: error
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "80%", myConf.height = "80%");
    const myDial = this.dialog.open(CapturedPaymentComponent, myConf);
    myDial.afterClosed().subscribe(() => {
      this.statusMessage = this.translate.instant("loaderRedirc_");
      this.loader = true;
      this.orderApi.redirectAfterErrorYetCaptured();
    })
  }

  // Nettoie les ressources Stripe qui auraient pu être initialisées.
  unmountStripe() {
    // TODO ???
  }

  // ouvre la pop up Mypos
  openMyPosPayment(data?: any, payment_intent_id?: any): void {
    const dataOrder: any = {
      orderCard: this.orderCard,
      billingAddress: this.billingAddress,
      delivryAddress: this.delivryAddress,
      selectedRelay: this.selectedRelay,
      isRelay: this.isRelay ? this.selectedRelay : null,
      paypalOrder: null,
      payment_intent_id: payment_intent_id,
    }
    this.setPageLoader(false);
    this.loader = true;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      amount: data.amount,
      metadata: "1", //provenance order
      dataOrder: dataOrder,
      merchantClient: this.merchantClient,
      checkOpenPof: true,
      mypos_account: data.mypos_account
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");
    const myDial = this.dialog.open(MyPosComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      this.tools.setOnPopState(true);
      if (result && result.success) {
        this.loader = true;
        this.setPaymentMypos(result.success.OrderID, result.success);
      } else {
        this.loader = false;
        this.setPageLoader(false);
        if (result && result.error && result.error == "errorYetPayed") {
          this.openDialogStatusStripeCapuredSucceded();
        }
      }
    });
  }

  // set payment my pos
  setPaymentMypos(order_id: any, paiement: any) {
    this.orderApi.myPosPaymentSucceeded(order_id, paiement).then(order => {
      if (order.code === 0) {
        this.handlePaymentSuccess();
      } else {
        this.loader = false;
        //error
        this.tools.openSnackBar(this.translate.instant('loginComp.error'), "warn", 5000);
      }
    }).catch(err => {
      console.error('err', err)
    })
    this.setPageLoader(false);
  }

  // calcul le discount client
  getPriceRemise() {
    if (this.merchantClient && this.merchantClient.id_group) {
      this.discountClient = this.totalPricePan - this.panierMan.getTotalAfterDiscount(this.merchantClient);
      this.allTotal -= this.discountClient;
    }
    return this.allTotal;
  }


  // BORNE touch terminal

  // dialog payment borne touch terminal
  openDialogtouchTerminal(info?: any): void {
    this.setPageLoader(false);
    this.loader = true;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.disableClose = true;
    myConf.data = {
      amount: info.total,
      order_id: info.order_id,
      order_payment_id: info.orderPayment.id,
      id_device: this.tools.getStor("devicePaybridge"),
      webshop_id: this.currPos.id_webshop
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "80%", myConf.height = "80%");
    const myDial = this.dialog.open(PaymentTouchTerminalComponent, myConf);
    this.borneOrderService.setborneDialo(myDial);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        if (result.code) {
          //error
          this.loader = false;
        }
        //ok
        if (result.status) {
          this.loader = result.status == 2 ? true : false;
          this.setPageLoader(true);
          this.setPaymentBorne(myConf.data, result);
        } else {
          this.loader = false;
        }
      } else {
        this.loader = false;
      }
      this.tools.setOnPopState(true);
      this.borneOrderService.setborneDialo(myDial);
    });
  }

  // set success payment borne touch terminal
  setPaymentBorne(info: any, pay_intent: any) {
    this.Touchterminalpayment.TouchTerminalPaymentSucceeded(info, pay_intent, this.credit_fid).then(order => {
      if (order.code === 0) {
        this.handlePaymentSuccess();
      } else {
        this.loader = false;
        this.tools.openSnackBar(this.translate.instant('loginComp.error'), "warn", 5000);
      }
    }).catch(err => {
      console.error('err', err)
    })
    this.setPageLoader(false);
  }

  onChangesalesTerms() {
    this.needSalesTerms = this.salesTerms ? false : true;
  }


  // Device Check

  timerSetOrderIntent(data: any) {
    this.time = 10;
    this.interval = setInterval(() => {
      if (this.time > 0) {
        this.time -= 1;
      }
      if (this.time == 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.loader = false;
        this.setPageLoader(false);
        const message = this.translate.instant('error_device_no_auto_creation');
        this.handleError(message, 5000);
      }
      if (this.interval) {
        this.getStatusOrderIntent(data);
      }
    }, 2000);
  }

  getStatusOrderIntent(data: any) {
    this.DeviceCheck.getStatusOrderIntent(data).then(value => {
      if (value.order_intent.status == 1) {
        //on stop le timer
        this.time = 0;
        //on continue
        this.submitOrder(null, data.order_id_device);
      }
    }).catch(err => {
      this.loader = false;
      this.setPageLoader(false);
      console.error('err', err)
    })
  }
  // set Order Intent for device
  //TODO
  setOrderIntentcheckDevice_(data: any) {
    return new Promise((resolve, reject) => {
      this.DeviceCheck.setOrderIntentDeviceCheck(data).then(order_intent => {
        if (order_intent && order_intent.code > 0) {
          data.order_intent_id = order_intent.id;
          //on attend la reponse
          this.timerSetOrderIntent_(data).then((result: any) => {
            this.loader = false;
            this.setPageLoader(false);
            resolve(result);
          }).catch(err => {
            console.error('err', err)
            this.loader = false;
            this.setPageLoader(false);
            const message = this.translate.instant('error_device_no_auto_creation');
            this.handleError(message, 5000);
            reject(err);
          });
        }
        if (order_intent && order_intent.code == -999) {
          this.loader = false;
          this.setPageLoader(false);
          const message = this.translate.instant('php.999_errorApi')//-999
          this.handleError(message, 5000);
          reject("err");
        }
      }).catch(err => {
        this.loader = false;
        this.setPageLoader(false);
        reject("error");
        console.error('err', err)
      })
    })
  }

  timerSetOrderIntent_(data: any) {
    return new Promise((resolve, reject) => {
      this.time = 10;
      this.orderIntentStatus = false;
      this.interval = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1;
        }
        //si le temps est fini
        if (this.time == 0 && this.interval) {
          clearInterval(this.interval);
          this.interval = null;
          if (!this.orderIntentStatus) {
            setTimeout(() => {
              const error = {
                "name": "nodevice",
              }
              reject(error);
            }, 0);
          }
        }
        if (this.interval) {
          //on recupere le orderintent
          this.getStatusOrderIntent_(data).then((value: any) => {
            if (value) {
              resolve(value);
            }
          }).catch((err: any) => {
            console.error('err', err)
            reject("error");
          })
        }
      }, 2000);
    })
  }

  getStatusOrderIntent_(data: any,) {
    return new Promise(() => {
      this.DeviceCheck.getStatusOrderIntent(data).then(value => {
        if (value.order_intent.status == 1) {
          this.time = 0;
          this.orderIntentStatus = true;
          this.submitOrderDevice(data.order_id_device);
        }
      }).catch(err => {
        this.loader = false;
        this.setPageLoader(false);
        console.error('err', err)
      })
    })
  }

  // Error
  handleError(data?: any, time?: any, abon?: any) {
    const t = time ? time : 8000;
    const message = data ? data : this.translate.instant('loginComp.error');
    if (!abon) {
      this.tools.openSnackBar(message, "warn", t);
    }
  }

  // submit order device
  submitOrderDevice(order_id_device: any) {
    this.orderApi.submitOrder(
      this.currPaymentChoice, // "counter" / "secure_counter" / "online_paypal" / ...
      null, // currCard
      this.billingAddress, // billingAddress
      this.delivryAddress, // delivryaddress
      (this.isRelay ? this.selectedRelay : null), // relay
      null, // paypal_order_id
      null, // payment_intent_id
      this.merchantClient, // merchantClient
      null, // paymentIntentId
      order_id_device, // order_id_device
      null, // url
      null, // payment_intent_id_saved
      this.uberFee // uberFee
    ).then(
      data => {
        // Success
        if (data.code === 0) {
          this.handlePaymentSuccess();
        } else {
          if (data && data.code && data.code === -134) {
            this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
          }
          if (data && data.code && data.code == -60) {
            //pas de client
            data.message = this.translate.instant('nocustomers');
          } else {
            this.tools.openSnackBar(data.message ? data.message : this.translate.instant('loginComp.error'), "warn", 10000);
          }
          this.setPageLoader(false);
        }
      }
    );
  }

  // fonction centralisatrice qui lance la livraison Uber quelque soit le paiement réussi.
  // fonction asynchrone pour attendre la réponse de Uber.
  private async handlePaymentSuccess(): Promise<void> {
    const order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
    // console.log("order_id : ", order_id);

    // CAS SANS UBER : comportement historique inchangé (non asynchrone)
    if (!this.uberQuote) {
      this.orderApi.endOrder();
      return;
    }

    // CAS AVEC UBER : on BLOQUE tant qu'on n'a pas la réponse Uber
    const delivery_infos = {
      delivery_address: this.delivryAddress,
      curPoS_info: this.currPos,
      uberQuote: this.uberQuote,
      client_Account_info: this.clientAccount,
      basket_info: this.panier$,
      order_id: order_id,
    };

    try {
      // const res: any = await this.uberService.createDelivery(delivery_infos, 10);

      // if (!res || (res.code !== undefined && res.code !== 0)) {
      //   // Uber refuse => pas de endOrder()
      //   this.loader = false;
      //   this.setPageLoader(false);
      //   this.tools.openSnackBar(
      //     this.translate.instant('uber.error.cannot_deliver'),
      //     'warn',
      //     10000
      //   );
      //   return;
      // }

      // Uber OK → on finalise la vente
      this.loader = false;
      this.setPageLoader(false);
      // if (res) {
      //   console.log("res : ", res);
      //   if (res.body) {
      //     console.log("res.body : ", res.body);
      //     if (res.body.tracking_url) {
      //       console.log("res.body.tracking_url : ", res.body.tracking_url);
      //     }
      //   }
      // }
      this.orderApi.endOrder();

    } catch (err) {
      console.error('[Uber] createDelivery technical error: ', err);
      this.loader = false;
      this.setPageLoader(false);
      this.tools.openSnackBar(
        this.translate.instant('uber.error.error_creation'),
        'warn',
        10000
      );
      return;
    }
  }


}
